// extracted by mini-css-extract-plugin
export default {"titleDiv":"CarouselInfoSkeleton_titleDiv__Mof2I"};